import { inject, InjectionToken } from "@angular/core";
import { Route } from "@angular/router";
import { DynamicTabsService } from "@app/shared-core/general/dynamic-tabs/dynamic-tabs.service";
import { APP_ROUTE_PATHS } from "@app/app-route-paths";
import { ExpirationSettingsRoutePaths } from "@app/applications/settings/domains/expiration-settings/expiration-settings-route-path";
import { stockExpirationSettingsRoutes } from "../stock-expiration-settings.routes";
import { StockExpirationSettingsRoutePaths } from "../stock-expiration-settings-route-path";
import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";

export const stockExpirationSettingsDynamicRoutesConfig: Route[] = [
  {
    path: ExpirationSettingsRoutePaths.EXPIRATION_SETTINGS,
    children: [
      {
        path: "",
        children: stockExpirationSettingsRoutes,
      },
    ],
  },
];

export const ADD_STOCK_EXPIRATION_SETTINGS_TABS = new InjectionToken("ADD_STOCK_EXPIRATION_SETTINGS_ROUTES", {
  providedIn: "root",
  factory: () => {
    inject(DynamicTabsService).addTabs(
      ExpirationSettingsRoutePaths.EXPIRATION_SETTINGS,
      [
        {
          route: StockExpirationSettingsRoutePaths.ROOT,
          label: "STOCK_EXPIRATION_SETTINGS.TITLES.STOCK_EXPIRATION_SETTINGS",
          permissions: [PERMISSION_CONSTANTS.STOCK_EXPIRATION_SETTINGS.VIEW, PERMISSION_CONSTANTS.STOCK_EXPIRATION_SETTINGS.SET],
        },
      ],
      { parentRoutePath: APP_ROUTE_PATHS.SETTINGS, routes: stockExpirationSettingsDynamicRoutesConfig }
    );
  },
});
